var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1885 15.0439C10.1885 15.8479 9.53732 16.4998 8.7334 16.5H5.82129C5.30668 16.5 4.85565 16.2321 4.59668 15.8291L10.1885 12.2578V15.0439ZM15.2852 0C16.089 0.000232534 16.7402 0.652138 16.7402 1.45605V15.0439C16.7402 15.8479 16.089 16.4998 15.2852 16.5H12.373C11.569 16.5 10.917 15.848 10.917 15.0439V11.793L13.1719 10.3535C14.6953 9.38039 14.6953 7.11957 13.1719 6.14648L10.917 4.70605V1.45605C10.917 0.651995 11.569 0 12.373 0H15.2852ZM10.1885 5.10547V11.3945L4.36816 15.1113C4.36714 15.089 4.36523 15.0666 4.36523 15.0439V1.45605C4.36523 1.43312 4.36711 1.41037 4.36816 1.3877L10.1885 5.10547ZM12.7793 6.76074C13.8548 7.44761 13.8548 9.05337 12.7793 9.74023L10.917 10.9287V5.57031L12.7793 6.76074ZM8.7334 0C9.53732 0.000198548 10.1885 0.652117 10.1885 1.45605V4.24121L4.59668 0.669922C4.85572 0.267264 5.30698 0 5.82129 0H8.7334Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7824 6.7602C13.8578 7.44707 13.8578 9.0529 12.7824 9.73977L2.61718 16.232C1.47753 16.9599 0.00195307 16.1193 0.00195313 14.7422L0.00195363 1.75776C0.00195369 0.380687 1.47753 -0.459885 2.61718 0.267977L12.7824 6.7602Z",
    fill: "url(#paint0_linear_659_5027)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_659_5027",
    x1: 0.284857,
    y1: -2.91901e-8,
    x2: 12.8283,
    y2: 16.4088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C60027"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.116be85227b45800a6029f1a86f48987.svg";
export { ForwardRef as ReactComponent };